// Overlay Search
function overlaySearch() {
	
	var overlaySearch = jQuery('.overlay-search');
	var overlaySearchBg = jQuery('.overlay-search-bg');
	var overlaySearchToggle = jQuery('.search-toggle');
	
	if ( overlaySearch.length && overlaySearchToggle.length ) {
		
		overlaySearchToggle.on( 'click', function(e) {
			
			e.preventDefault;
			
			overlaySearch.removeClass('hidden').addClass('visible');
			
		});
		
		overlaySearchBg.on( 'click', function() {
			
			jQuery(this).parent().parent().removeClass('visible').addClass('hidden');
			
		});
		
	}
	
}

jQuery(document).ready( overlaySearch() );


// Back to top
var $backToTop = $('.back-to-top');

if ($backToTop.length) {
  
  var scrollTrigger = 100;
  var window = jQuery(window);
      
  function backToTop() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > scrollTrigger) {
      $backToTop.addClass('show');
    } else {
      $backToTop.removeClass('show');
    }
  };
  backToTop();
  
  $(window).on( 'scroll', function () {
    backToTop();
  });
  
  $backToTop.on( 'click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });
  
}